import { NumericFormat } from "react-number-format";

const IncomeStatementTable = ({ data = {} }) => {
  const formatPrice = (price) =>
    new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    }).format(price);

  const revenue = data.revenue || { items: [], total: 0 };
  const expenses = data.expenses || { items: [], total: 0 };
  const netIncome = data.net_income || 0;

  return (
    <div className="w-full">
      <style>{`
        @media print {
          nav, .card-header, .no-print { 
            display: none !important; 
          }
          thead { 
            background: #1e3a8a !important; 
            -webkit-print-color-adjust: exact; 
            print-color-adjust: exact;
          }
          .gradient-bg {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
        }
      `}</style>

      <table className="w-full border border-collapse text-sm">
        <thead className="bg-blue-900 text-white sticky top-0 z-10">
          <tr>
            <th className="p-3 border text-left">Kode</th>
            <th className="p-3 border text-left">Nama Akun</th>
            <th className="p-3 border text-right">Jumlah</th>
          </tr>
        </thead>
        <tbody>
          {/* PENDAPATAN (REVENUE) */}
          <tr className="bg-gradient-to-r from-green-50 to-green-100 font-bold gradient-bg">
            <td colSpan="3" className="p-3 border">
              <div className="flex items-center gap-2">
                <i className="mgc_currency_dollar_2_line text-green-600 text-lg"></i>
                <span className="text-green-800">PENDAPATAN</span>
              </div>
            </td>
          </tr>

          {revenue.items.length > 0 ? (
            revenue.items.map((item, idx) => (
              <tr
                key={idx}
                className="hover:bg-green-50 transition-colors duration-150"
              >
                <td className="p-2 border font-mono text-sm">{item.account_code}</td>
                <td className="p-2 border pl-6">{item.account_name}</td>
                <td className="p-2 border text-right font-semibold">
                  {formatPrice(item.amount)}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" className="p-2 border text-center text-gray-500 italic">
                Tidak ada data pendapatan
              </td>
            </tr>
          )}

          {/* TOTAL PENDAPATAN */}
          <tr className="bg-green-100 font-bold">
            <td colSpan="2" className="p-3 border text-right">
              Total Pendapatan
            </td>
            <td className="p-3 border text-right text-green-700">
              {formatPrice(revenue.total)}
            </td>
          </tr>

          {/* SPACING */}
          <tr className="h-4">
            <td colSpan="3" className="border-0"></td>
          </tr>

          {/* BEBAN (EXPENSES) */}
          <tr className="bg-gradient-to-r from-red-50 to-red-100 font-bold gradient-bg">
            <td colSpan="3" className="p-3 border">
              <div className="flex items-center gap-2">
                <i className="mgc_invoice_line text-red-600 text-lg"></i>
                <span className="text-red-800">BEBAN</span>
              </div>
            </td>
          </tr>

          {expenses.items.length > 0 ? (
            expenses.items.map((item, idx) => (
              <tr
                key={idx}
                className="hover:bg-red-50 transition-colors duration-150"
              >
                <td className="p-2 border font-mono text-sm">{item.account_code}</td>
                <td className="p-2 border pl-6">{item.account_name}</td>
                <td className="p-2 border text-right font-semibold">
                  {formatPrice(item.amount)}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" className="p-2 border text-center text-gray-500 italic">
                Tidak ada data beban
              </td>
            </tr>
          )}

          {/* TOTAL BEBAN */}
          <tr className="bg-red-100 font-bold">
            <td colSpan="2" className="p-3 border text-right">
              Total Beban
            </td>
            <td className="p-3 border text-right text-red-700">
              {formatPrice(expenses.total)}
            </td>
          </tr>

          {/* SPACING */}
          <tr className="h-4">
            <td colSpan="3" className="border-0"></td>
          </tr>

          {/* LABA/RUGI BERSIH */}
          <tr className={`font-bold text-lg ${netIncome >= 0 ? 'bg-blue-100' : 'bg-orange-100'}`}>
            <td colSpan="2" className="p-4 border text-right">
              {netIncome >= 0 ? 'LABA BERSIH' : 'RUGI BERSIH'}
            </td>
            <td className={`p-4 border text-right ${netIncome >= 0 ? 'text-blue-700' : 'text-orange-700'}`}>
              {formatPrice(Math.abs(netIncome))}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default IncomeStatementTable;
